export default [
  {
    itemType: 'group',
    colCount: 1,
    items: [
      {
        dataField: 'modalidade',
        label: { text: 'Descrição' },
        validationRules: [{
          type: 'required',
          message: 'Descrição é obrigatório'
        }]
      },
      {
        dataField: 'quitacao_direta',
        label: { text: 'Quitação Direta' },
        editorType: 'dxSelectBox',
        editorOptions: {
          items: [
            { value: 'S', label: 'Sim' },
            { value: 'N', label: 'Não' }
          ],
          displayExpr: 'label',
          valueExpr: 'value'
        }
      }
    ]
  }
]
